import { Component, OnInit, Input, ElementRef, ViewChild, HostListener, ComponentFactory, ViewContainerRef, ComponentFactoryResolver, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { LookupConfiguration, LookupResult } from './lookup.config';
import { BaseComponent } from '../../core/component/Base.Component';
import { AppConstants } from "../../app.constant";
import { AgGridComponent } from '../grid/aggrid.component';
import { ColDef } from 'ag-grid';
import * as moment from 'moment';
import { GridCheckBoxComponent } from "../grid/editors/checkbox/checkboxcomponent";

@Component({
	selector: 'ixs-lookup',
	templateUrl: 'lookup.component.html'
})
export class LookupComponent extends BaseComponent {
	@ViewChild('modal')
	public modal: ModalComponent;
	@ViewChild('modal')
	public nativemodal: any;
	@Input()
	public Config: LookupConfiguration[];
	@Input()
	public Data: any[];
	@Input()
	public Caption: String;
	@Input()
	public LookupId: String;

	totalrecord: number = 0;

	private dateFormat: string = AppConstants.settings.dateFormatforString;
	private timeFormat: string = AppConstants.settings.timeFormatforString;
	@ViewChild("lookupGrid", { read: ViewContainerRef }) container;
	componentRef: any;


	@ViewChild(AgGridComponent) lookupGrid: AgGridComponent;

	constructor(private resolver: ComponentFactoryResolver) {
		super();

	}

	async ngOnInit() {
		this.modal.backdrop = 'static';
		this.modal.keyboard = true;
		var caption = this.Caption ? this.Caption.replace("*", "") : this.Caption
		this.Caption = caption;
	}
	async drag() {

		$('.modal-dialog').draggable({
			handle: ".modal-header"
		});
		$('modal-dialog').css({ top: 0, left: 0, right: 0, bottom: 0, });
	}
	async open() {
		
		this.setColumns();
		this.container.clear();
		const factory: ComponentFactory<any> = this.resolver.resolveComponentFactory(AgGridComponent);
		this.componentRef = this.container.createComponent(factory);
		this.componentRef.instance.hideSelection = false;
		this.componentRef.instance.hideSerial = false;
		this.componentRef.instance.hideAdd = true;
		this.componentRef.instance.hideDelete = true;
		this.componentRef.instance.hideRecord = false;

		this.componentRef.instance.filter = true;

		this.componentRef.instance.columns = this.columns;
		this.componentRef.instance.data = this.Data;
		this.componentRef.instance.pagination = true;
		this.componentRef.instance.pageSize = "15";
		this.componentRef.instance.ExportCombo = true;
		// await this.componentRef.instance.onRowClicked.subscribe((event) => {
			
		// 	this.select(event);
			
		// })

		await this.componentRef.instance.onRowClicked.subscribe((event) =>{
			
			this.select(event);
		})

		this.modal.keyboard = true;
		await this.drag();

		if (this.Data) {
			this.totalrecord = this.Data.length;
		}
		setTimeout(async () => {
			
			await this.modal.open('lg');
			
			var api = this.componentRef.instance.options.api;
			
			if (api) {
				
				this.componentRef.instance.options.enableSorting = true;
				await this.componentRef.instance.Filtershow();
				await this.componentRef.instance.changePageSize();
				
			}
		}, 0);
	}

	select(event) {

		this.broadcast.publish<LookupResult>('lookup', <LookupResult>{
			lookupId: this.LookupId,
			data: event.data
		});

		this.innerClose();
	}

	
	async innerClose() {

		this.modal.keyboard = false;
		$(".modal-backdrop").remove(':last');
		this.modal.close();
		this.onListerClose.emit(this);
	}

	@HostListener("document:keyup", ["$event"]) handleKeyUp(event) {
		if (this.modal.keyboard === true && event.keyCode === 27) {
			this.innerClose();
		}

	}

	public columns: any = [];

	async setColumns() {
		
		if (this.Config) {
			var col = [{
				headerName: "",
				field: "lookupcol",
				editable: false,
				width: 15,
				cellClass: "grid-filter-remove",
				filter: true,

			}];
			
			this.Config.forEach(element => {
				
				let obj = {
					headerName: element.caption,
					field: element.name,
					width: element.width ? Number(element.width.replace("px", "")) : 200,
					cellClass: "grid-column",
					filter: false,
					cellRendererFramework: element.type === 'checkbox' ? GridCheckBoxComponent : undefined,
					cellFormatter: data => {
						if (element.type && element.type === 'date' && data && data.value) {
							return moment(data.value).format(this.dateFormat);
						}
						else if (element.type && element.type === 'time' && data && data.value) {
							return moment(data.value).format(this.timeFormat);
						}
					},
					
					editable: false,
				}
				col.push(obj);
				
			});
			
			if (col) {

				var data = col[1];
				 data.cellClass = "grid-first-column";
				 
				}
			this.columns = col;
			
		}
	}

	@Output()
	onListerClose: EventEmitter<any> = new EventEmitter<any>();

}



// WEBPACK FOOTER //
// ./src/app/components/lookup/lookup.component.ts